<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    상품관리
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_payment_detail "
                         @click="movePage(`/service/product`)"
                    >
                        결제상품
                    </div>
                    <div class="write_tab_content tab_payment_detail active"
                    >
                        서비스 이용요금
                    </div>

                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box">
                            <point-write-component :point-type="'service'"></point-write-component>
                    <div class="btn_box">
                        <el-button class="com_btn" @click="writePoint()">저장</el-button>
                    </div>
                        </div></div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PointWriteComponent from "@/components/point/PointWriteComponent";
import EventBus from "@/utils/event-bus";
export default {
  name: "ProductService",
  mixins: [],
  components: {
      PointWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      movePage(url){
          this.$router.push(url)
      },
      writePoint(){
          EventBus.$emit('writePoint')
      }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
